<template>
  <AppSelect
    v-bind="$attrs"
    :theme="theme"
    :error="error"
    v-on="$listeners"
  />
</template>

<script>
import AppSelect from '@/components/common/inputs/AppSelect'

export default {
  // Name
  name: 'AppSelectWithValidation',

  // Components
  components: {
    AppSelect
  },

  // Inherit Attrs
  inheritAttrs: false,

  // Props
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    hideError: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'green'
    },
    error: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
</style>
